import { PersistedMetamodel } from '@ardoq/api-types';
import { distinctUntilChanged, map, Observable } from 'rxjs';
import { metamodelNavigation$ } from './navigation/metamodelNavigation$';

export const metamodel$: Observable<PersistedMetamodel | null> =
  metamodelNavigation$.pipe(
    map(({ metamodel }) => metamodel ?? null),
    distinctUntilChanged()
  );
